import * as React from "react";
import * as moment from "moment";

import { Appointment, WorkingHours } from "./models";
import { Day } from "./Day";

export interface WeekProps {
    days: moment.Moment[];
    entityId?: string;
    appointments?: Appointment[];
    workingHours: WorkingHours;
    hourHeight: number;
    onAppointmentClick?: (appointment: Appointment) => void;
    onAppointmentDrop?: (itemId: string, appointment: Appointment) => void;
    onHourDrop?: (itemId: string, hour: moment.Moment, entityId: string) => void;
    onHourClick?: (hour: moment.Moment, entityId: string) => void;
}

export class Week extends React.Component<WeekProps> {
    public render() {
        const { days, entityId, hourHeight } = this.props;
        return (
            <>
                {days.map(day => {
                    const appointmentsInDay = this.props.appointments && this.props.appointments.filter(appointment =>
                        appointment.start.isSameOrBefore(day.clone().endOf("day")) && appointment.end.isSameOrAfter(day));
                    const isWorkingDay = !this.props.workingHours
                                        || !this.props.workingHours.workingDays
                                        || this.props.workingHours.workingDays.indexOf(day.weekday()) !== -1;

                    return (
                        <Day
                            date={day}
                            entityId={entityId}
                            hourSize={hourHeight}
                            key={day.valueOf()}
                            timeDirection="vertical"
                            appointments={appointmentsInDay}
                            workingDayStartTime={this.props.workingHours && this.props.workingHours.workingDayStartTime}
                            workingDayEndTime={this.props.workingHours && this.props.workingHours.workingDayEndTime}
                            workingDay={isWorkingDay}
                            onAppointmentClick={this.props.onAppointmentClick}
                            onAppointmentDrop={this.props.onAppointmentDrop}
                            onHourDrop={this.props.onHourDrop}
                            onHourClick={this.props.onHourClick}
                        />
                    );
                })}
            </>
        );
    }
}
